export namespace Mathematics {
  export function average(value, count, decimals?: number): number {
    // tslint:disable-next-line:no-shadowed-variable
    let average = value / count;
    if (decimals) {
      return Number(average.toFixed(decimals));
    }
    return average;
  }

  export function arrayVariation(input: Array<number>): number {
    let filterPredicate = entry => entry !== null && entry !== undefined;
    let first = null;

    let firstFilter = input.filter(filterPredicate);
    if (firstFilter.length) {
      first = firstFilter[0];
    }
    let last = null;
    let lastFilter = input.reverse().filter(filterPredicate);
    if (lastFilter.length) {
      last = lastFilter[0];
    }

    if (first === null || last === null) {
      return null;
    } else {
      return last - first;
    }
  }

  export function arraySum(input: Array<number>): number {
    let sum = 0;
    for (let i of input) {
      sum += i;
    }
    return sum;
  }
}



// WEBPACK FOOTER //
// ./src/app/mathematics.ts